var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgPlus16X16 = function SvgPlus16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.037 10.976v-8.81a1.035 1.035 0 10-2.073 0v8.81H2.153a1.036 1.036 0 100 2.073h8.81v8.811a1.035 1.035 0 102.074 0v-8.81h8.81a1.034 1.034 0 001.037-1.037c0-.573-.463-1.037-1.037-1.036h-8.81z",
    fill: "#9CA6AD"
  })));
};

export default SvgPlus16X16;